import Super from '../../core/button.gjs';
import styles from './ghost.module.scss';

export default class SpdsActionButtonGhost extends Super {
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-ghost';
  variantStyles = styles;
}
